var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"empty-state"},[_c('v-icon',{attrs:{"size":_vm.size,"color":"mediumGray"}},[_vm._v(_vm._s(_vm.icon))]),_c('p',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }